import React, { useState } from "react";
import { Share2, Video } from "lucide-react";
import { ClassCard } from "./ClassCard";
import { ShareModal } from "./ShareModal";
import { useClassSchedule } from "./classSchedule";

export default function HowItWorks() {
  const [shareOpen, setShareOpen] = useState(false);
  const classSchedule = useClassSchedule();

  return (
    <section id="how-it-works" className="relative scroll-mt-28 py-14 md:py-16 sep-top" style={{ background: "#1A1852" }} data-testid="how-it-works-section">
      <div className="mx-auto max-w-6xl px-6 md:px-10">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-3">
            <span className="h-px w-10" style={{ background: "linear-gradient(90deg, transparent, rgba(66,165,245,0.65), transparent)" }} />
            <span
              className="font-mono-label section-eyebrow home-eyebrow"
              style={{ color: "#E8C97A", letterSpacing: "0.12em" }}
            >
              Live EazyBot Classes
            </span>
            <span className="h-px w-10" style={{ background: "linear-gradient(90deg, transparent, rgba(66,165,245,0.65), transparent)" }} />
          </div>
          <h2
            className="font-display mt-3 leading-[1.05]"
            style={{ fontSize: "clamp(1.5rem,2.6vw,2.1rem)", color: "#fff" }}
            data-testid="how-it-works-heading"
          >
            How EazyBot Works
          </h2>
          <p className="mt-3 text-sm md:text-base max-w-xl mx-auto" style={{ color: "rgba(255,255,255,0.7)" }}>
            Attend a live EazyBot class to learn more details and get <br className="hidden md:block" />your questions answered.
          </p>
        </div>

        <div className="mx-auto max-w-5xl">
          <ClassCard schedule={classSchedule} />
          <div className="mt-5 flex flex-wrap justify-center gap-3">
            <a
              href="https://us06web.zoom.us/j/2480049812"
              target="_blank"
              rel="noopener noreferrer"
              className={`btn-lift inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold ${classSchedule.isLive ? "live-class-pulse" : ""}`}
              style={{ background: classSchedule.isLive ? "#DC2626" : "#D4A24C", color: classSchedule.isLive ? "#ffffff" : "#141034" }}
              data-testid="how-it-works-join-class"
            >
              {classSchedule.isLive ? (
                <><span aria-hidden="true">●</span> Join Live Class Now</>
              ) : (
                <><Video className="h-4 w-4" /> Join Class</>
              )}
            </a>
            <button
              type="button"
              onClick={() => setShareOpen(true)}
              className="btn-lift inline-flex items-center justify-center gap-2 rounded-full border px-6 py-3 text-sm font-semibold"
              style={{ borderColor: "rgba(212,162,76,0.65)", color: "#F2C977", background: "rgba(212,162,76,0.07)" }}
              data-testid="how-it-works-share"
            >
              <Share2 className="h-4 w-4" /> Share
            </button>
          </div>
        </div>
      </div>
      <ShareModal open={shareOpen} onClose={() => setShareOpen(false)} />
    </section>
  );
}
